"use strict";
document.addEventListener("DOMContentLoaded", function handleSidebarDisplay() {
    const sidebar = document.getElementById('sidebar');
    if (sidebar && !(sidebar === null || sidebar === void 0 ? void 0 : sidebar.innerText)) {
        sidebar.style.display = 'none';
    }
});
